module.exports = __webpack_public_path__ + "img/grade-3.06d271db.png";